export { default } from "../getPrototypeOf/_index.mjs"